import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { FlexBox } from '@ecp/common/src/layouts/flex/styled';
import useSwiperPaging from '@ecp/common/src/components/swiper/useSwiperPaging';

import { numberOrStringType } from '../../../../style/propTypes';

const Wrapper = styled(FlexBox)`
  position: absolute;
  width: 100%;
  justify-content: center;
  bottom: ${({ bottom }) => `-${bottom}`};
`;

const currentStyle = css`
  width: 20px;
  background: ${(props) => props.theme.color.icon.current};
`;

const Page = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 8px;
  background: ${(props) => props.theme.color.icon.default};
  margin-right: 6px;
  cursor: pointer;

  ${({ isCurrent }) => (isCurrent ? currentStyle : '')}
  &:last-of-type {
    margin-right: 0;
  }
`;

const SwiperBrandPaging = (props) => {
  const { current, bottom = '24px', newTotal } = props;
  let totalCount = newTotal;

  const { handlePaging } = useSwiperPaging(props);
  const pages = useMemo(() => [...Array(Math.max(0, totalCount))], [totalCount]);
  return (
    <Wrapper bottom={bottom} height="8px" align-items="flex-end" className="swiper-pagination">
      {pages.map((page, index) => (
        <Page
          isCurrent={index === current - 2}
          index={index}
          current={current}
          key={`swiper-paging__${index}`}
          onClick={(e) => handlePaging(e, index)}
        />
      ))}
    </Wrapper>
  );
};

SwiperBrandPaging.propTypes = {
  bottom: numberOrStringType,
  current: PropTypes.number,
  total: PropTypes.number,
  slidesPerView: PropTypes.number,
  handlePrev: PropTypes.func,
  handleNext: PropTypes.func,
  newTotal: PropTypes.number,
};

SwiperBrandPaging.defaultProps = {
  bottom: '24px',
};

export default SwiperBrandPaging;
